import getConfigDetails from '../services/config'

export const APICONFIG = {
	// login and singup
	singInUrl: `${getConfigDetails.baseURL}v1/oauth/access_token`,
	sendOtpUrl: `${getConfigDetails.baseURL}oauth/otp/send`,
	singupUrl: `${getConfigDetails.baseURL}v1/sign-up`,
	// 
	getUserLoginUrl: `${getConfigDetails.baseURL}`,
	postCitationUrl: `${getConfigDetails.baseURL}citation-make-payment`,
	// getCitationUrl: `${getConfigDetails.baseURL}citation-rate`
	getPartnerBySlug: `${getConfigDetails.baseURL}partner-details-by-slug`,

	//  citaitoon--url
	// getCitationUrl: `${getConfigDetails.baseURL}diamond-citation-details`, for demo commented
	getCitationUrl: `${getConfigDetails.baseURL}diamond-citation-details`,
	// before payment 
	// postBeforePayemntUrl: `${getConfigDetails.baseURL}diamond-citation-before-payment`,
	// postAfterPayemntUrl: `${getConfigDetails.baseURL}diamond-citation-after-payment`,

	// for demo 
	postBeforePayemntUrl: `${getConfigDetails.baseURL}diamond-citation-before-payment`,
	postAfterPayemntUrl: `${getConfigDetails.baseURL}diamond-citation-after-payment`,

	//  for appeal demo 
	createAppealUrl: `${getConfigDetails.baseURL}appeal-file`,

	// 
	getVehicleDetailsUrl: `${getConfigDetails.baseURL}get-all-make-models`,

	createVoidUrl: `${getConfigDetails.baseURL}partner-warning-citation-update`,
	// STORE EVENT LOG
	storeEventLog: `${getConfigDetails.baseURL}addUserEvent`,
}
